import { useTranslation } from 'react-i18next';

import { useGetMe } from '../../api/generated/identity/identity';
import { PanelSection, panelState } from './PanelSection';
import {
  ClassList,
  NextClass,
  nextUpcoming,
  occurrencesPanelQuery,
  upcoming,
  useHomeOccurrences,
} from './UpcomingClasses';
import styles from './dashboard.module.css';

/**
 * Painel do professor.
 *
 * **Nao tem lista de alunos, e isso e requisito.** A §9.3 da revisao 1.2 e a
 * §2.2 do mestre sao categoricas: com o nome mascarado, dois alunos podem
 * aparecer como `João S.` sem desambiguador. O professor sempre age a partir do
 * contexto de uma aula, e nao de uma lista de pessoas — e e por isso que a home
 * dele e a agenda, com horario, tipo e estado, sem nome nenhum.
 *
 * As duas secoes saem da **mesma** consulta: `listOccurrences` na janela da
 * home. Nao ha operacao nova aqui, e o cartao "Em breve" saiu.
 */
export function TeacherHome() {
  const { t } = useTranslation();
  const meQuery = useGetMe();
  const me = meQuery.data;

  // A janela inteira, e nao a primeira pagina dela: ver `useHomeOccurrences`.
  // Cinco aulas por dia passam de 50 ocorrencias em quinze dias, e "a quinzena"
  // cortada em silencio e a mesma mentira que a docstring de `ClassList` recusa
  // — so que maior.
  const occurrences = useHomeOccurrences(!!me);

  if (!me) return null;

  const janela = occurrencesPanelQuery(occurrences);
  const next = panelState(janela, (items) => nextUpcoming(items));
  const agenda = panelState(janela, (all) => {
    const items = upcoming(all);
    return items.length > 0 ? items : undefined;
  });

  return (
    <>
      <h1 className={styles.title}>{t('dashboard.teacher.title')}</h1>

      <PanelSection
        id="teacher-next-action"
        title={t('dashboard.nextAction')}
        state={next}
        empty={t('dashboard.nextActionEmpty')}
      >
        {(occ) => <NextClass me={me} occ={occ} />}
      </PanelSection>

      <PanelSection
        id="teacher-schedule"
        title={t('schedule.title')}
        state={agenda}
        empty={t('schedule.empty')}
      >
        {(items) => <ClassList me={me} items={items} />}
      </PanelSection>
    </>
  );
}
